import React from 'react';
import { Box } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LaptopIcon from '@mui/icons-material/Laptop';
import HomeIcon from '@mui/icons-material/Home';
import SelectorModule from '../common/SelectorModule';

const BookingOptions = ({
  languages, modalities,
  selectedLanguage, setSelectedLanguage,
  selectedModality, setSelectedModality,
  disabled = false,
  modalityDisabled = disabled
}) => {

  const languageOptions = [
    { id: 'espanol', title: 'Español', icon: '🇲🇽' },
    { id: 'english', title: 'English', icon: '🇺🇸' },
    { id: 'frances', title: 'Français', icon: '🇫🇷' }
  ];

  const modalityOptions = [
    { id: 'Presencial', title: 'Presencial', desc: 'Sitio del proveedor', icon: <LocationOnIcon fontSize="small" /> },
    { id: 'Remoto', title: 'Remoto', desc: 'Online', icon: <LaptopIcon fontSize="small" /> },
    { id: 'Domicilio', title: 'Domicilio', desc: 'En tu dirección', icon: <HomeIcon fontSize="small" /> }
  ];

  const filteredLanguages = languageOptions.filter(opt => 
    languages.map(l => l.toLowerCase()).includes(opt.id) || 
    languages.map(l => l.toLowerCase()).includes(opt.title.toLowerCase())
  );

  const filteredModalities = modalityOptions.filter(opt => 
    modalities.includes(opt.id)
  );

  // Convert incoming "language" name to lowercase ID if necessary
  const currentLangId = selectedLanguage?.toLowerCase() || 'espanol';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {filteredLanguages.length > 0 && (
        <SelectorModule
          title="Idiomas disponibles"
          subtitle={disabled ? "Idioma predefinido en la cotización personalizada" : "Selecciona el idioma en el que se impartirá el servicio"}
          options={filteredLanguages}
          value={currentLangId}
          onChange={setSelectedLanguage}
          premium
          disabled={disabled}
        />
      )}

      {filteredModalities.length > 0 && (
        <SelectorModule
          title="Modalidad"
          subtitle={modalityDisabled ? "Modalidad predefinida en la cotización personalizada" : "Elige la modalidad que prefieras"}
          options={filteredModalities}
          value={selectedModality}
          onChange={setSelectedModality}
          premium
          disabled={modalityDisabled}
        />
      )}
    </Box>
  );
};

export default BookingOptions;
